<template>
  <div class="sp-template">
    <div class="h-title">仓库</div>
    <el-card class="box-card">
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button size="small" @click="queryList()">查询</el-button>
          <el-button v-if="in_configs(20101)" size="small" @click="addWarehouse">新建仓库</el-button>
        </div>
      </div>
      <el-table :data="warehouseData" stripe border>
        <el-table-column prop="name" label="仓库名称"></el-table-column>
        <el-table-column prop="orgOp" label="所属组织"></el-table-column>
        <el-table-column prop="warehouseAddress.countryCode" label="国家"></el-table-column>
        <el-table-column prop="warehouseAddress.province" label="省份"></el-table-column>
        <el-table-column prop="phone" label="仓库电话"></el-table-column>
        <el-table-column prop="timeZone" label="所属时区"></el-table-column>
        <el-table-column prop="currency" label="货币"></el-table-column>
        <el-table-column prop="splitOrderDelivery" label="发货分单" :formatter="formatDelivery"></el-table-column>
        <el-table-column prop="partReceipt" label="部分收货" :formatter="formatReceipt"></el-table-column>
        <el-table-column prop="virtual" label="虚拟仓" :formatter="formatVirtual"></el-table-column>
        <el-table-column label="启用">
          <template slot-scope="scope">
            <el-switch v-model.lazy="scope.row.enable" @click.native="changeStatus(scope.$index, scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="70px">
          <template slot-scope="scope">
            <el-dropdown trigger="click" >
							<el-button plain size="small">...</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item size="mini" type="text" v-if="in_configs(20102)" @click.native="handleEdit(scope.$index, scope.row)">编辑</el-dropdown-item>
								<el-dropdown-item size="mini" type="text" v-if="in_configs(20103)" @click.native="handleLook(scope.$index, scope.row)">查看</el-dropdown-item>
								<el-dropdown-item size="mini" type="text" v-if="in_configs(20104)" @click.native="handleDelete(scope.$index, scope.row)">删除</el-dropdown-item>
							</el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" 
      layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <!-- 地图 -->
    <!-- <sp-amap id="sp-amap" :class="{isOpen: isOpen}" :isOpen="isOpen" @get-geocoder="getGeocoder" @get-city="getCity"></sp-amap> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      //高德地图-----------
      isOpen: false,
      mapAddressFormVisible: false,
      //---------高德地图
      isLook: false,
      // loading: true,
      title: "新建仓库",
      warehouseData: [],
      warehouseForm: {
        id: "",
        name: "",
        warehouseAddress: {
          countryCode: "",
          province: "",
          city: "",
          address: "",
          postCode: "",
          position: ""
        },
        street: "",
        phone: "",
        length: "",
        height: "",
        width: "",
        managePersonName: "",
        managePersonPhone: "",
        receiptPersonName: "",
        receiptPersonPhone: "",
        timeZone: "",
        currency: "",
        remarks: "",
        splitOrderDelivery: false,
        virtual: false,
        enable: false,
        partReceipt: false
      },
      currentPage: 1, //当前页
      total: 0, //总条数
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      isManagePhone: false,
      isReceiptPhone: false,
      status: 0
    };
  },
  components: {},
  created() {
    // this.getCity;
    // setTimeout(() => {
    //   this.queryWarehouseData();
    //   this.loading = false;
    // }, 1000);
    this.queryList()
  },
  computed: {},
  methods: {

    queryList(){
      this.currentPage = 1
      this.pageSize = 10
      this.queryWarehouseData()
    },
    //高德地图----------
    //获取经纬度：
    // getCity(val) {
    //   console.log(val);
    // },
    // getGeocoder(val) {
    //   this.warehouseForm.warehouseAddress.position = val.lng + "," + val.lat;
    //   console.log("获取经纬度： " + JSON.stringify(val));
    // },
    //高德地图保存地址
    handleSmenSaveMap() {
      this.mapAddressFormVisible = false;
    },
    //高德地图----------
    queryWarehouseData() {

      this.$request1({
        method: 'GET',
        url: '/warehouse/query',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(response => {
          this.warehouseData = response.data.data;
          this.total = response.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatDelivery(data) {
      return data.splitOrderDelivery ? "是" : "否";
    },
    formatReceipt(data) {
      return data.partReceipt ? "是" : "否";
    },
    formatVirtual(data) {
      return data.virtual ? "是" : "否";
    },
    addWarehouse() {
      this.$router.push({
        path: "warehouse/new",
        query: {
          operate: 'new'
        }
      });
    },
    //编辑
    handleEdit(index, row) {
      this.$router.push({
        path: "warehouse/new",
        query: {
          operate: 'edit',
          row: encodeURIComponent(JSON.stringify(row))
        }
      });
    },
    //查看
    handleLook(index, row) {
      this.$router.push({
        path: "warehouse/new",
        query: {
          operate: 'look',
          row: encodeURIComponent(JSON.stringify(row))
        }
      });
    },
    //启用、禁用仓库
    changeStatus(index, row) {
      this.$request1({
        method: 'POST',
        url: '/warehouse/status',
        params: {
          warehouseId: row.id,
          status: row.enable
        }
      })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
          this.$message.error("操作失败");
        });
    },
    //删除
    handleDelete(index, row) {
      let self = this;
      this.$confirm("此操作将永久删除该仓库, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'get',
            url: '/warehouse/delete',
            params: { warehouseId: row.id }
          })
            .then(response => {
              self.warehouseData.splice(index, 1);
              this.$message({
                message: "删除成功",
                type: "success",
                center: true,
                duration: 1500
              });
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(_ => {});
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //分页
    handleSizeChange(pageSizes) {
      this.pageSize = pageSizes;
      this.queryWarehouseData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.queryWarehouseData();
    }
  }
};
</script>

<style lang="scss">
#sp-amap {
  position: fixed;
  top: 0;
  right: 100%;
  width: 100%;
  &.isOpen {
    position: relative;
    right: 0;
  }
}
.error .el-input__inner {
  border-color: red !important;
}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/warehouse.vue